// Application imports
import '@/main-files/base'
import Vue from 'vue'
import App from '@/vue-pages/HomeValues'
import vuetify from '@/plugins/vuetify'
import '@/plugins/maps'


new Vue({
    vuetify,
    render: h => h(App),
}).$mount('#app')
